import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ApolloConsumer  } from "react-apollo";
// import { menuMovie } from '../../links/linksHome';
import { LIMIT_ITEMS_MEDIA } from '../../constants/Common';
import { getMoreMoviesByCate } from '../../graphqlDic';
import MoviesMediaUI  from '../CommonComponents/MoviesMediaUI';

class CateMoviesComponent extends Component {

    constructor(props) {
        super(props);
        if (props.dataCategory) {
            let { hot_medias, medias } = props.dataCategory;
            let cursorMedias = props.dataCategory.pageInfoMedias.endCursor;
            let cursorMediasHot = props.dataCategory.pageInfoHotMedias.endCursor;
            let namePage = props.dataCategory.category.name;
            
            let { totalCountMedias } = props.dataCategory;
            let { totalCountHotMedias } = props.dataCategory;
            let toggleBtnViewMore = medias.length < totalCountMedias ? true : false;
            let toggleBtnViewMoreHot = hot_medias.length < totalCountHotMedias ? true : false;

            this.state = {
                toggleMovie: true,
                toggleBtnViewMore,
                toggleBtnViewMoreHot,
                hot_medias: hot_medias ? hot_medias : [],
                medias: medias ? medias : [],
                cursorMedias,
                cursorMediasHot,
                namePage
            }
        }
    }

    
      
    componentDidUpdate() {
        this.scrollToBottom();
    }

    scrollToBottom = () => {
        this.contentMovies.scrollIntoView({ block: "end", behavior: "smooth" });
    }

    onToggleMovie = (param) => {
        let toggleMovie = param === -1 ? true : false;
        if (param !== this.state.toggleMovie) {
            this.setState({
                toggleMovie
            });
        }
    }

    showMedias = () => {
        let result = [];
        let { toggleMovie, hot_medias, medias } = this.state;
        let showMainMedias = toggleMovie ? medias : hot_medias;
        if (showMainMedias.length) {
            result = showMainMedias.map((media, index) => {
                return (
                    <Link to={ '/media/watch/' + media.id } key={ index } >
                        <MoviesMediaUI dataMedias={ media } />
                    </Link>   
                );
            });
        }
        return result.length ? result : <span className="text-center">Không có phim nào trong danh sách</span>;
    }

    onViewMore = data => {
        let { medias } = data.getMoreMoviesByCate;
        let { endCursor } = data.getMoreMoviesByCate.pageInfo;
        let { toggleMovie } = this.state;
        if (data && medias.length) {
            let curentMedias = toggleMovie ? this.state.medias : this.state.hot_medias;
            let totalCount = toggleMovie ? this.props.dataCategory.totalCountMedias : this.props.dataCategory.totalCountHotMedias;
            let newResMedias = curentMedias.concat(medias);

            let toggleBtn = newResMedias.length < totalCount ? true : false;

            toggleMovie ? 
            this.setState({
                medias: newResMedias,
                cursorMedias: endCursor,
                toggleBtnViewMore: toggleBtn
            }) :

            this.setState({
                hot_medias: newResMedias,
                cursorMediasHot: endCursor,
                toggleBtnViewMoreHot: toggleBtn
            })
        }
    }

    render() {

        let { toggleMovie, toggleBtnViewMore, toggleBtnViewMoreHot } = this.state;
        let { namePage } = this.state;
        let hot_mode = !toggleMovie;
        let cursor = toggleMovie ? 
                     this.state.cursorMedias :
                     this.state.cursorMediasHot;
        let category_id  = this.props.dataCategory.category._id;
        return (
            <div className="movie-euro" ref={(el) => { this.contentMovies = el; }}>
                <div className="container">
                    <div className="top clearfix">
                        <div className="pull-left">
                            <ul className="list-inline breadcumb">
                                {/* <li><Link to={menuMovie.path}>Phim</Link><span> / </span></li> */}
                                <li>{ namePage }</li>
                            </ul>
                        </div>
                        <div className="pull-right">
                            <ul className="list-inline list-movie">
                                <li className={ toggleMovie ? 'active' : '' }>
                                    <a 
                                        className="cursorPT"
                                        onClick={ () => this.onToggleMovie(-1) }
                                    >Phim Mới
                                    </a>
                                </li>
                                <li className={ !toggleMovie ? 'active' : '' }>
                                    <a 
                                        className="cursorPT"
                                        onClick={ () => this.onToggleMovie(1) }
                                    >Phim Hot
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="main clearfix">
                        { this.showMedias() }
                    </div>
                </div>
                
                { (toggleBtnViewMore && toggleMovie) || (toggleBtnViewMoreHot && !toggleMovie) ? 
                <ApolloConsumer>
                    { client => (
                        <button 
                            type="button" 
                            className="center-block btn btn-primary"
                            onClick={ async (e) => {
                                let btnViewMore = e.target;
                                btnViewMore.disabled = true;
                                this.watingViewMore.style.display = 'inline-block';
                                const { data } = await client.query({
                                    query: getMoreMoviesByCate,
                                    variables: {
                                        category_id: category_id,
                                        cursor,
                                        first: LIMIT_ITEMS_MEDIA,
                                        hot_mode
                                    }
                                });
                                btnViewMore.disabled = false;
                                this.watingViewMore.style.display = 'none';
                                this.onViewMore(data);
                            }}
                        > 
                        <i 
                            className="fa fa-refresh fa-spin" 
                            style={{display: 'none'}}
                            ref={(el) => { this.watingViewMore = el; }}
                        ></i> Xem thêm...
                        </button>
                    ) }
                </ApolloConsumer> : null}
            </div>
        );
    }

}

export default CateMoviesComponent;



// WEBPACK FOOTER //
// ./src/components/MoviePageComponent/CateMoviesComponent.js